// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l9ibrirLZLwL2Laleigi{padding:33px 0 8px}.xGFvqu9SB4wz5tGR2OnP{color:var(--content-primary-tertiary);padding-top:16px}.BFCVt4ZCVg9qGjUbPEud{gap:8px;display:flex}.Btb_S1JYbFEr4VHXxEQw{margin:24px 0 0}.GZmCfHd4DaYLPXidaMgm{flex-direction:column;gap:4px;margin-left:4px;display:flex}.ByBQbOpzbmAr_tQbnlNq{cursor:pointer}.UsRNNgWIz_0SoaPgqaXO{background-color:var(--background-neutral-subtle);border-radius:8px;align-items:center;gap:8px;padding:16px;display:flex}.LbGtXKyq8MsZsE1nJiXe{background:var(--black-20);border-radius:6px;justify-content:center;align-items:center;width:20px;height:20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `l9ibrirLZLwL2Laleigi`,
	"description": `xGFvqu9SB4wz5tGR2OnP`,
	"actionsWrap": `BFCVt4ZCVg9qGjUbPEud`,
	"alert": `Btb_S1JYbFEr4VHXxEQw`,
	"alertInfo": `GZmCfHd4DaYLPXidaMgm`,
	"link": `ByBQbOpzbmAr_tQbnlNq`,
	"step": `UsRNNgWIz_0SoaPgqaXO`,
	"step__number": `LbGtXKyq8MsZsE1nJiXe`,
	"stepNumber": `LbGtXKyq8MsZsE1nJiXe`
};
export default ___CSS_LOADER_EXPORT___;
